module.exports = __webpack_public_path__ + "media/fonts/Inter-Regular-9ca9ba81.ttf";